import React, { useContext } from 'react';
import classNames from 'classnames';
import LiquiditySummaryGrid from 'widgets/liquiditySummary/grid/LiquiditySummaryGrid';
import './LiquiditySummary.scss';
import {
    usePortfolioSelectedSymbolQuantity,
    usePortfolioSelectedOrders,
} from 'portfolio/store/hooks';
import { getLiquiditySummaryData } from 'widgets/liquiditySummary/liquiditySummaryData';
import AppContext from 'app/AppContext';
import LiquiditySummaryChart from 'widgets/liquiditySummary/chart/LiquiditySummaryChart';
import { isInitialLiquiditySummaryData } from 'widgets/liquiditySummary/store/data/LiquiditySummaryDataState';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useWidgetContext } from 'widgets/WidgetContext';
import { useLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';

export default function LiquiditySummary() {
    const { widgetKey } = useWidgetContext();

    useWidgetStream();

    const { useWidgetStreamData } = liquidityStreamedDataSelectors;
    const streamData = useWidgetStreamData();

    const symbolQuantity = usePortfolioSelectedSymbolQuantity();
    const orders = usePortfolioSelectedOrders();
    const { config } = useLiquiditySummaryConfigSlice();

    const {
        currencyFormat: { exchangeRate },
    } = useContext(AppContext);

    const data = getLiquiditySummaryData(
        streamData,
        exchangeRate ?? 1,
        symbolQuantity?.qty ?? 0,
        symbolQuantity?.qtyRemaining,
        orders[0]?.side
    );

    const haveData =
        symbolQuantity && data && !isInitialLiquiditySummaryData(streamData);
    const dataClass = haveData ? '' : 'no-data';
    const sideClass = data ? data.sideClass : '';

    const dataProp = haveData ? data : undefined;

    return (
        <div
            className={classNames('LiquiditySummary', sideClass, dataClass)}
            data-widget-id={widgetKey}
        >
            {config.view === 'grid' && (
                <LiquiditySummaryGrid data={dataProp} haveData={!!haveData} />
            )}
            {config.view === 'chart' && (
                <LiquiditySummaryChart
                    data={dataProp}
                    haveData={!!haveData}
                    symbol={symbolQuantity?.symbol ?? ''}
                />
            )}
        </div>
    );
}
